import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/search_back.png'
import _imports_1 from '@/assets/images/search_nodata.png'


const _withScopeId = n => (_pushScopeId("data-v-18760e64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { action: "/" }
const _hoisted_2 = {
  key: 0,
  class: "search"
}
const _hoisted_3 = { class: "titleBox" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "searchList" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "cellCon"
}
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "noDataBox" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1 /* HOISTED */))
const _hoisted_11 = { class: "titleBox" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "cellCon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("form", _hoisted_1, [
      _createVNode(_component_van_search, {
        class: "inputBox",
        shape: "round",
        modelValue: $setup.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.value) = $event)),
        placeholder: _ctx.$t('home.searchplace'),
        onSearch:  $setup.onSearch 
      }, {
        left: _withCtx(() => [
          _createElementVNode("img", {
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onCancel()))
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue", "placeholder", "onSearch"])
    ]),
    _createCommentVNode(" 搜索记录 "),
    _createCommentVNode(" <div v-if=\"historyList.length > 0 && !isData\" class=\"search\">\n                            <div class=\"titleBox\">\n                              <div class=\"title\">搜索记录</div>\n                              <van-icon name=\"delete-o\" size=\"20px\" class=\"delBtn\" @click=\"clearHistory\" />\n                            </div>\n                            <div class=\"searchList\">\n                              <div v-for=\"(item, index) in historyList\" :key=\"index\" @click=\"onSearch(item, false)\"> {{ item }}</div>\n                            </div>\n                          </div> "),
    _createCommentVNode(" 大家都在搜索 "),
    (!$setup.isData && $setup.hotSearch.length > 0 && !$setup.isData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('home.veryonesearch')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotSearch, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key:  index ,
                onClick: ($event: any) => ($setup.uitlsToLiveRoom(item, $setup.router))
              }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_6))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    ( $setup.isData && $setup.searchList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.searchList, (item, index) => {
            return (_openBlock(), _createBlock($setup["MatchCell"], {
              key:  index ,
              item:  item 
            }, null, 8 /* PROPS */, ["item"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" 没有结果 "),
    ( $setup.isData && $setup.hotList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('tips.kkry')), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('home.index_title_zb')), 1 /* TEXT */)
          ]),
          _createCommentVNode(" <SeachMatch :match=\"hotList\" /> "),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.hotList, (item, index) => {
              return (_openBlock(), _createBlock($setup["MatchCell"], {
                key:  index ,
                item:  item 
              }, null, 8 /* PROPS */, ["item"]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}